// Material ui components
// Apollo client
import { useQuery } from '@apollo/client';
import { Box, Grid } from '@material-ui/core';

// Global components
import Competence from '../../../../../components/Competence';
import { If } from '../../../../../components/If';
import { PanelLogin } from '../../../../../components/PanelLogin';
import PaperPanelInfo from '../../../../../components/PaperPanelInfo';
import Subtitle from '../../../../../components/Subtitle';
import { useAuthContext } from '../../../../../context/AuthContextProvider';
import ipanema from '../../../../../graphql/clients/ipanema';
import { GET_FIDC_CADASTRAL_DATA_FROM_MONTH_AND_YEAR_BY_OPERATION_HASH_ID } from '../../../../../graphql/queries';

export default function OperationFIDCLiabilityData({ hash }) {
  const { auth } = useAuthContext();
  const { data, loading, error } = useQuery(
    GET_FIDC_CADASTRAL_DATA_FROM_MONTH_AND_YEAR_BY_OPERATION_HASH_ID,
    {
      variables: { hash },
      client: ipanema,
      skip: !auth?.user?.subscription?.plan?.permissions[
        'operacoes_fidic_passivo_dados'
      ],
    },
  );

  if (error) return null;

  return (
    <div>
      <Subtitle title="Dados" />
      <Competence value={hash} searchType="HASH_ID" />
      <Box py={2}>
        <If
          condition={
            !auth?.user?.subscription?.plan?.permissions[
              'operacoes_fidic_passivo_dados'
            ]
          }>
          <PanelLogin />
        </If>
        <If
          condition={
            auth?.user?.subscription?.plan?.permissions[
              'operacoes_fidic_passivo_dados'
            ]
          }>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6} md={3} lg>
              <PaperPanelInfo
                numeric
                title="Passivo"
                value={
                  data?.getFidcCadastralDataFromMonthAndYearByOperationHashId
                    ?.liability
                }
                loading={loading}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg>
              <PaperPanelInfo
                numeric
                title="Patrimônio Líquido"
                value={
                  data?.getFidcCadastralDataFromMonthAndYearByOperationHashId
                    ?.netWorth
                }
                loading={loading}
              />
            </Grid>
          </Grid>
        </If>
      </Box>
    </div>
  );
}
